import $ from 'jquery';
import SliderRange from 'blocks/slider-range/slider-range';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaTariffMobile',
			dom: {
				sliderRange: '.js-slider-range',
				price: '#yotaTariffMobilePrice',
				togglerSms: '#yotaTariffMobileTogglerSms',
				togglerApp: '#yotaTariffMobileTogglerApp',
				sms: '#yotaTariffMobileSms',
				app: '#yotaTariffMobileApp',
				// speed: {
				// 	hour2: '.js-tariff-set-2hour',
				// 	hour24: '.js-tariff-set-24hour'
				// },
				input: {
					minutes: '#yotaTariffMobileInputMinutes',
					price: '#yotaTariffMobileInputPrice'
				},

				set: {
					data: '.js-tariff-mobile-setdata',
					hide: '.js-tariff-mobile-hidefor'
				}

			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.activated = false;
		this.price = false;
		return this;
	}

	getDom() {
		this.$sliderRange = this.$el.find(this.options.dom.sliderRange);
		this.$price = this.$el.find(this.options.dom.price);
		this.$togglerSms = this.$el.find(this.options.dom.togglerSms);
		this.$togglerApp = this.$el.find(this.options.dom.togglerApp);
		this.$sms = this.$el.find(this.options.dom.sms);
		this.$app = this.$el.find(this.options.dom.app);
		this.input = {};
		this.input.$minutes = this.$el.find(this.options.dom.input.minutes);
		this.input.$price = this.$el.find(this.options.dom.input.price);

		this.set = {};
		this.set.$data = $(this.options.dom.set.data);
		this.set.$hide = $(this.options.dom.set.hide);
		return this;
	}

	onSlide(position, rate) {
		rate.action = rate.action || false;
		this.rate = rate;
		this.price = this.rate.price;
		this.setPrice(false, rate.price);
		this.input.$minutes.val(this.rate.minutes);
		this.input.$price.val(this.rate.price);
		this.$el.data('params', [this.rate.ancor]);
		this.$window.trigger('yota.router.check');

		this.updateData();
	}


	setPrice(event, price) {
		const set = price || this.price;
		let text = set + parseInt(this.data.internet);

		if (this.unlimitedSms()) {
			text += parseInt(this.data.unlimitedSmsPrice);
		}
		if (this.unlimitedApp()) {
			text += parseInt(this.data.unlimitedAppPrice);
		}
		this.$price.text(text);

		this.updateData();
	}

	unlimitedSms() {
		if (this.$togglerSms.prop('checked')) {
			return true;
		}
		return false;
	}

	unlimitedApp() {
		if (this.$togglerApp.prop('checked')) {
			return true;
		}
		return false;
	}

	activate() {
		const self = this;
		if (!self.activated && self.$el.data('activated') === true) {
			self.activated = true;
			setTimeout(function () {
				self.sliderRange.animate();
			}, 100);
		}
	}

	update() {
		const params = this.$el.data('params') || [];
		if (params.length) {
			this.data.baseRate = this.sliderRange.getRate(params[0], 'ancor').rate.price;
			this.sliderRange.update({base: this.data.baseRate});
		}
	}

	updateData() {
		const self = this;
		const data = {};
		data.app = self.$togglerApp.prop('checked') ? 'on' : 'off';
		data.sms = self.$togglerSms.prop('checked') ? 'on' : 'off';
		data.price = String(self.rate.price);
		data.minutes = String(self.rate.minutes);
		data.internet = String(self.rate.internet);
		data.ancor = String(self.rate.ancor);

		self.set.$data.each(function () {
			const $this = $(this);
			const param = $this.data('param');
			if (typeof data[param] != 'undefined') {
				$this.html(data[param]);
			}
		});

		self.set.$hide.each(function () {
			const $this = $(this);
			const param = $this.data('param');
			const showon = $this.data('showon') || false;
			const hideon = $this.data('hideon') || false;
			const values = (showon || hideon).split('|');
			const show = showon !== false && hideon === false;

			if (typeof data[param] != 'undefined') {
				const hasValue = values.indexOf(data[param]) !== -1;
				if (show && hasValue || !show && !hasValue) {
					$this.show();
				} else {
					$this.hide();
				}
			}
		});
	}

	render() {
		if (this.$el.length) {
			if (yotaPortlets.tariffMobile) {
				this.data = yotaPortlets.tariffMobile;

				this.price = this.data.baseRate;
				this.getDom();

				this.$togglerSms.on('change', this.setPrice.bind(this));
				this.$togglerApp.on('change', this.setPrice.bind(this));
				this.$sms.html(this.data.unlimitedSmsPrice);
				this.$app.html(this.data.unlimitedAppPrice);

				this.sliderRange = new SliderRange({
					el: this.$sliderRange,
					base: this.data.baseRate,
					rates: this.data.rates,
					callback: {
						update: this.onSlide.bind(this)
					}
				});

				const labels = [];
				$.each(this.data.rates, function (key, item) {
					labels.push({
						js: key,
						price: item.minutes,
						internet: item.internet
					});
				});


				this.$el
					.on('yota.router.activate', this.activate.bind(this))
					.on('yota.router.update', this.update.bind(this))
					.trigger('yota.router.update');

				this.sliderRange.render();
				this.sliderRange.buildLabels(labels, true);
				this.sliderRange.onSlide(this.sliderRange.position);

				this.$el.data('params', [this.rate.ancor]);

				this.$window.trigger('yota.router.check');
				this.$el.trigger('yota.router.activate');
			} else {
				console.error('The tariffMobile portlet has no data, set data to "yotaPortlets.tariffMobile"');
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/tariff-mobile/tariff-mobile.js